/**
 * @author  Kheops Technologies SA <devops@kheops.ch>
 * @copyright Kheops Technologies SA
 */
import OxFieldText from './OxFieldText.vue'
export * from './OxFieldText.vue'
export default OxFieldText
